require('../modules/web.immediate');
module.exports = require('../modules/$.core').setImmediate;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/set-immediate.js
// module id = 1879
// module chunks = 14